module.exports = __webpack_public_path__ + "media/images/vector_marketplace@2x-f995cf4edf8eabbe8961ef24ffb404ec.png";